export default __webpack_public_path__ + "static/media/Inter-Bold.88fa7ae3.ttf";